import React from "react";
import { Badge } from "reactstrap";

/** Partner Go-live workflow: marketing-style labels. */
const WORKFLOW_MAP = {
  active: { label: "Live", color: "success" },
  pending: { label: "Pending approval", color: "warning" },
  draft: { label: "Draft", color: "secondary" },
  inactive: { label: "Inactive", color: "danger" },
  suspended: { label: "Suspended", color: "danger" },
};

/** Clinics and generic entities: operational status wording. */
const LISTING_MAP = {
  active: { label: "Active", color: "success" },
  pending: { label: "Pending", color: "warning" },
  draft: { label: "Draft", color: "secondary" },
  inactive: { label: "Inactive", color: "danger" },
  suspended: { label: "Suspended", color: "danger" },
};

function normalizePartnerWorkflowStatusKey(status) {
  const s = String(status ?? "").trim().toLowerCase();
  if (s === "active") return "active";
  if (s === "pending") return "pending";
  if (s === "draft") return "draft";
  if (s === "inactive") return "inactive";
  if (s === "suspend" || s === "suspended") return "suspended";
  return "";
}

/**
 * Workflow / listing status badge for partner admin (English labels).
 * @param {"workflow"|"listing"} labelMode — `workflow`: Go live wording; `listing`: clinic row wording.
 */
const PartnerStatusBadge = ({ status, labelMode = "workflow" }) => {
  const map = labelMode === "listing" ? LISTING_MAP : WORKFLOW_MAP;
  const key = normalizePartnerWorkflowStatusKey(status);
  const info = (key && map[key]) || { label: status ? String(status) : "—", color: "secondary" };
  return (
    <Badge className={`badge-dim badge-${info.color}`} pill>
      {info.label}
    </Badge>
  );
};

export default PartnerStatusBadge;
